var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { "padding-top": ".98rem" } }, [
    _c("div", { staticClass: "fixedBox" }, [
      _c("div", { staticClass: "fixedTopBox" }, [
        _c("div", { staticClass: "backIcon" }),
        _vm._v(" "),
        _c("div", { staticClass: "back", on: { click: _vm.back } }),
        _vm._v(" "),
        _c("div", { staticClass: "topTitle" }, [_vm._v("服务助手")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "rule", on: { click: _vm.clearAllNoReadForUser } },
          [_vm._v("清除未读")]
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "ul",
      [
        _vm._l(_vm.systemMessageList, function(item) {
          return _c("li", [
            _c(
              "div",
              { staticClass: "topBox", class: { active: item.readed } },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm._f("isType")(item.type)) +
                    " "
                ),
                _c("span", { class: { active: item.readed } }, [
                  _vm._v(_vm._s(_vm._f("time")(item.createTime)))
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", class: { active: item.readed } },
              [_vm._v(_vm._s(item.content))]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "bottomBox",
                class: { active: item.readed },
                on: {
                  click: function($event) {
                    _vm.to("serviceAssistantDetail?messageId=" + item.messageId)
                  }
                }
              },
              [_vm._v("\n                查看详情 "), _c("span")]
            )
          ])
        }),
        _vm._v(" "),
        _c("no-more-data", { attrs: { noMoreData: _vm.noMoreData } })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9705418e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9705418e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/serviceAssistant.vue
// module id = null
// module chunks = 